/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getNotificationPreferencesResponse = zod.object({
  "channels": zod.array(zod.enum(['Email', 'Inbox', 'Push', 'SignalR', 'Slack', 'Sms'])),
  "types": zod.array(zod.object({
  "key": zod.string(),
  "displayName": zod.string(),
  "description": zod.string(),
  "group": zod.enum(['Pay', 'Payouts', 'PayoutMethods', 'Funding', 'Payees', 'Opportunities', 'FieldService', 'Documents', 'Account', 'System']),
  "channels": zod.array(zod.enum(['Email', 'Inbox', 'Push', 'SignalR', 'Slack', 'Sms'])),
  "mutedChannels": zod.array(zod.enum(['Email', 'Inbox', 'Push', 'SignalR', 'Slack', 'Sms']))
}))
})

export const updateNotificationMuteParams = zod.object({
  "typeKey": zod.string(),
  "channel": zod.enum(['Email', 'Inbox', 'Push', 'SignalR', 'Slack', 'Sms'])
})

export const updateNotificationMuteBody = zod.object({
  "muted": zod.boolean()
})

